import type { TourStep } from '../types';

export const designerTariffsSteps: TourStep[] = [
  { target: '[data-tour="designer-tariffs-table"]', title: 'Тарифы за макеты', content: 'В таблице указана стоимость работы для каждого типа макета.' },
  { target: '[data-tour="designer-tariffs-table"]', title: 'Как читать тариф', content: 'Сопоставьте тип и сложность задания с указанной ставкой.' },
];
